<template>
  <div class="container-fluid">
    <div class="d-flex justify-content-between pb-3 align-items-center">
      <div>
        <div class="h3 font-weight-bold my-0">
          {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
        <div class="text-muted my-0">
          <span class="text-primary">Home</span> / Master Files / {{ $t($route.name.toLowerCase().replace(/ /g, '_') + ".plural") }}
        </div>
      </div>
      <div>
        <button
          class="btn2 btn2-primary btn2-md mr-1 mb-3 mb-sm-0"
          @click="$refs.createExperience.show()"
          v-if="role_modules.some(item => item.value == 'experience_level.create')"
        >
          <i class="uil-plus mr-1"></i> {{$t('experience_level.action.create_record')}}
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-xl-12">
      <Table
        ref="list"
        :useView="role_modules.some(item => item.value == 'experience_level.view')"
        :useEdit="role_modules.some(item => item.value == 'experience_level.edit')"
        :useDelete="true"
        noTitle
        :params="params"
        :fields="fields"
        :action="role_modules.some(item => item.value == 'experience_level') ? action : false"
        @openFormBar="openFormBar"
        @delete="onDeleteExperience"
      />
      </div>
    </div>
    <Dialog
      centered
      title="View Experience"
      ref="viewExperience"
      size="md"
      :component="viewComponent"
      :parameters="{ experienceLevelID, submitted }"
      v-if="role_modules.some(item => item.value == 'experience_level.view')"
    />
    <Dialog
      centered
      autoload
      is_reset_model
      title="Create Experience"
      ref="createExperience"
      size="md"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :component="createComponent"
      @onYes="onCreateExperience"
      v-if="role_modules.some(item => item.value == 'experience_level.create')"
    />
    <Dialog
      centered
      autoload
      title="Update Experience"
      ref="editExperience"
      size="md"
      yesText="Update"
      noText="Cancel"
      :buttonDisable="updated"
      :component="editComponent"
      :parameters="{experienceLevelID, submitted }"
      @onYes="onUpdateExperience"
      v-if="role_modules.some(item => item.value == 'experience_level.edit')"
    />
    <Dialog
      centered
      autoload
      title="Delete Experience"
      ref="deleteExperience"
      size="md"
      yesText="Delete"
      noText="Cancel"
      :buttonDisable="deleted"
      :component="deleteComponent"
      :parameters="{experienceLevelID, submitted }"
      @onYes="onDeleteExperience"
    />
  </div>
</template>

<script>
import Table from '@components/table'
import moment from 'moment/moment'
import Dialog from '@components/offcanvas'
import CreateComponent from './components/dialogs/create.vue'
import ViewComponent from './components/dialogs/view.vue'
import EditComponent from './components/dialogs/edit.vue'
import DeleteComponent from './components/dialogs/delete.vue'

import error from '@utils/error'

export default {
  components: {
    Table,
    Dialog
  },
  computed: {
    role_modules() {
      return this.$store.state.auth.role_modules || [];
    },
    createComponent () {
      return CreateComponent
    },
    viewComponent () {
      return ViewComponent
    },
    editComponent () {
      return EditComponent
    },
    deleteComponent () {
      return DeleteComponent
    },
  },
  data() {
    return {
      fields: [
				{
          label: this.$t('experience_level.table.name'), 
          key:"name",
          sortable: true
        },
        {
          label: this.$t('experience_level.table.date_created'), 
          key:'date_created', formatter: (val) => moment(val).format('YYYY-MM-DD')
        },
        {
          key:'actions',
          label:''
        }
      ],
      params: {},
      action: 'experience_level/pagination',
      items: [], // Array to hold fetched data
      experienceLevelID: '',
      submitted: false,
      created: false,
      updated: false,
      deleted: false,
    }
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.$store.dispatch('experience_level/pagination', this.params);
        this.items = response.data.data; // Bind fetched data to the table
      } catch (error) {
        console.error('Error fetching experience levels:', error);
      }
    },
    openFormBar(id, isEdit = false, isDelete = false) {
      this.experienceLevelID = id;
      if (isEdit) {
        this.$refs.editExperience.show();
      } else if (isDelete) {
        this.$refs.deleteExperience.show();
      } else {
        this.$refs.viewExperience.show();
      }
    },
    
    onCreateExperience(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('experience_level/create', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData(); // Ensure consistent table refresh
          this.$refs.createExperience.hide();
          this.$bvToast.toast('Experience successfully created!', {
            title: "Notification",
            variant: "success"
          });
          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },

    onUpdateExperience(val) {
      this.updated = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      model.id = model._id ? model._id : model.id ? model.id : ''

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.updated = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      return this.$store.dispatch('experience_level/update', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData()
          this.$refs.editExperience.hide()
          this.submitted = !this.submitted
          this.$bvToast.toast(`Experience successfully updated!`, {
            title: "Notification",
            variant: 'success'
          })
          setTimeout(() => {
            this.updated = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.updated = false;
        return error.errorHandler(err, this.$bvToast);
      })
    },
    
        
    onDeleteExperience(val) {
      if (typeof val === 'string') {
        this.experienceLevelID = val;
        if (this.$refs.deleteExperience) {
          this.$refs.deleteExperience.show();
        }
        return;
      }
      
      this.deleted = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val;
      
      if (!model.id && !model._id && this.experienceLevelID) {
        model.id = this.experienceLevelID;
      } else {
        model.id = model._id ? model._id : model.id ? model.id : '';
      }

      return this.$store.dispatch('experience_level/delete', { ...model })
      .then(res => {
        if (res && res.data) {
          this.$refs.list.fetchData(); // Ensure table refresh works
          if (this.$refs.deleteExperience) {
            this.$refs.deleteExperience.hide();
          }
          this.submitted = !this.submitted;
          this.$bvToast.toast(`Experience successfully deleted!`, {
            title: "Notification",
            variant: 'success'
          });
          setTimeout(() => {
            this.deleted = false;
          }, 1500);
        }
      })
      .catch(err => {
        this.deleted = false;
        return error.errorHandler(err, this.$bvToast);
      });
    },
  },
}
</script>